import { Enum } from '../enum.js';

export const ReportType = Enum(['project', 'staffMember', 'invoice', 'timesheet']);
